import { setLocaleCookie } from "./setLocaleCookie";
import { getLocaleFromCookie } from "./getLocaleFromCookie";
import auth0Config from "./auth0ConfigHelper";

export const getLocale = (): string => {
  const searchParams = new URLSearchParams(window.location.search);
  const queryLocale = searchParams.get("locale");
  const loginHint = auth0Config?.extraParams.login_hint;
  const localeFromCookie = getLocaleFromCookie();
  const locale =
    queryLocale ??
    (loginHint && JSON.parse(loginHint)?.locale) ??
    localeFromCookie ??
    "en_??";

  if (queryLocale) {
    searchParams.delete("locale");
    window.location.search = searchParams.toString();
  }

  if (!localeFromCookie || locale !== "en_??") {
    setLocaleCookie(locale);
    return locale;
  }

  return localeFromCookie;
};
